import { render, staticRenderFns } from "./audience-item.vue?vue&type=template&id=45955a8a"
import script from "./audience-item.vue?vue&type=script&lang=js"
export * from "./audience-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports